import {PostCatCountDiscounts} from "../post-models/post-cat-count-discounts";

export class ResponseCatCountDiscounts extends PostCatCountDiscounts{
    id?: number;
    isCompanyGrid?:boolean;
}